import { BaseEntity } from "./BaseEntity";

export class ProductEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.contracts.product.product";
        this.pageTitle = "components.contracts.product.pageTitle";
        this.menuPath = "/Resources";
        this.APIRoute = "Resources/Contracts"
        this.i18nBase = "components.contracts.product";
        this.baseEndPoint = "product";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
            activate: `${this.baseEndPoint}/:id/activate`,
            deactivate: `${this.baseEndPoint}/:id/deactivate`
        };

        this.fields = [
            {
                key: "identity",
                label: "common.labels.code",
                type: "text",
                visible: true,
                editable: true,
                cols: 6,
                path: "identity"
            },
            {
                key: "name",
                label:  `common.labels.name`,
                type: "text",
                visible: true,
                editable: true,
                cols: 6,
                path: "name"
            },
            {
                key: "price",
                label: "common.labels.price",
                type: "text",
                visible: true,
                editable: true,
                path: "price",
                cols: 3

            },
            {
                key: "st_product_service",
                label:  "common.labels.type",
                type: "text",
                visible: true,
                cols: 3,
                path: "st_product_service"
            },
            {
                key: "category",
                label: "Categoria",
                type: "text",
                visible: true,
                cols: 3,
                path: "category"
            },
            {
                key: "max_download",
                label: "Max download",
                type: "text",
                visible: true,
                cols: 3,
                path: "max_download"
            },
            {
                key: "max_upload",
                label: "Max upload",
                type: "text",
                visible: true,
                cols: 3,
                path: "max_upload"
            }
        ]

        this.customActions = {
            duplicate: false
        }


        this.tableColumns = [
            {
                key: "identity",
                label: "common.labels.code",
                visible: true,
                orderBy: true
            },
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: false
            },
            {
                key: "price",
                label: "common.labels.price",
                visible: true,
                orderBy: false
            },
            {
                key: "st_product_service",
                label: "common.labels.type",
                visible: true,
                orderBy: false
            },
            // {
            //     key: "status",
            //     label:  "common.labels.status",
            //     visible: true,
            //     orderBy: false
            // },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.productColumns = [
            {
                key: "identity",
                label: "common.labels.code",
                visible: true,
                orderBy: false
            },
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: false
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.pages = {
            view: {
                pageTitle: `${this.i18nBase}.product`,
                pathI18n: `/${this.i18nBase}.pageTitle`,
                route: ["/products", "/products/view/:id"]
            },
            list: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: "",
                route:  ["/products"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "st_product_service",
                                label: "common.labels.type",
                                type: "select",
                                options: [
                                    { label: "Serviço", value: "S" },
                                    { label: "Produto", value: "P" },
                                ],
                                path:"status"
                            },
                            // {
                            //     key: "status",
                            //     label: "common.labels.status",
                            //     type: "select",
                            //     options: [
                            //         { label: "common.labels.active", value: true },
                            //         { label: "common.labels.inactive", value: false },
                            //     ],
                            //     path:"status"
                            // },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
